module.exports = __webpack_public_path__ + "static/jinjibu-banner-7e80077d9e3beaec1839dcce2b863a70.svg";